import {Injectable} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FieldConfig, FieldType} from './field.interface';
import {SettingsService} from "../../../services/settings.service";

@Injectable({providedIn: 'root'})
export class DynamicFormService {

  constructor(private formBuilder: UntypedFormBuilder, private settings: SettingsService) {
  }

  showWhenObj: { [key: string]: any } = {};
  selectedKeyValue: { [key: string]: any } = {};

  isVisible(field: FieldConfig, form?: UntypedFormGroup, option?: any): boolean {


    if (option) {
      this.selectedKeyValue[field.key as string] = option;
    }

    let visible = true;

    if (field.showWhen && field.key) {


      if (field.showWhen.match(/(?<=\[)[^\][]*(?=])/g)) {
        this.showWhenObj[field.key] = field.showWhen.match(/(?<=\[)[^\][]*(?=])/g); // get string inside []
      }

      if (this.showWhenObj[field.key]?.length > 0) {
        const showWhenWithoutSpace = field.showWhen!.replace(/\s/g, ''); // removing all whitespace
        const outerJoiningValues = showWhenWithoutSpace.match(/\](.*?)\[/g) || []; // get string inside ][
        const visibleResults = this.showWhenObj[field.key].map((showWhen: string) => this.checkShowWhen({
          ...field,
          showWhen
        }, form));
        visible = this.checkAllConditions(outerJoiningValues, visible, visibleResults);
        return visible;
      } else {
        visible = this.checkShowWhen(field, form)
      }


    }


    return visible;
  }


  private checkShowWhen(field: FieldConfig, form: UntypedFormGroup | undefined): boolean {
    let visible = true;
    const conditions: { [key: string]: any } = {};
    const allVisibleResults: boolean[] = []; // true , false
    let joiningValues: any[] = []; //  }&&{ for && , }||{ for ||
    let showWhen: string[] = [];
    const showWhenWithoutSpace = field.showWhen!.replace(/\s/g, ''); // removing all whitespace
    showWhen = showWhenWithoutSpace.match(/({([^}]*)})/g) || []; // get string inside {}
    joiningValues = showWhenWithoutSpace.match(/\}(.*?)\{/g) || []; // get string inside }{


    let count = 0;
    showWhen.forEach((item: string) => {
      conditions[count] = item.match(/\((.*?)\)/g); // get string inside ()
      conditions[count] = conditions[count].map((el: string) => el.replace('(', '').replace(')', '') // Removing ()
      );
      const conditionObjectArr = conditions[count][0].split('.'); // check if key contains '.' meaning its a object
      let controlValue = null;
      if (conditionObjectArr.length === 1) {
        controlValue = form?.get(conditionObjectArr[0])?.value;
      } else if (conditionObjectArr.length === 2 && Object.keys(this.selectedKeyValue).length > 0) {
        controlValue = this.selectedKeyValue[conditionObjectArr[0]][conditionObjectArr[1]];
      }
      const matchControlValue: string = (conditions[count][2] === 'true' || conditions[count][2] === 'True' || conditions[count][2] === 'TRUE')
        ? true
        : (conditions[count][2] === 'false' || conditions[count][2] === 'False' || conditions[count][2] === 'FALSE')
          ? false
          : (conditions[count][2] === 'null' || conditions[count][2] === 'Null' || conditions[count][2] === 'NULL')
            ? null
            : conditions[count][2];


      visible = this.isValid(controlValue || null, matchControlValue || null, conditions[count][1]); // Checking for Conditions Validity
      allVisibleResults.push(visible);
      count++;
    });

    visible = this.checkAllConditions(joiningValues, visible, allVisibleResults);
    return visible;
  }

  private checkAllConditions(joiningValues: any[], visible: boolean, allVisibleResults: boolean[]) {
    let joinValCount = 0;
    let previousResult = allVisibleResults[joinValCount];
    joiningValues.forEach((joinValue) => {
      joinValCount++;
      // if (joinValCount % 2 != 0) {
      if (joinValue === '}&&{') {
        visible = previousResult && allVisibleResults[joinValCount];
        // if (!visible)
        //   return;
      } else if (joinValue === '}||{') {
        visible = previousResult || allVisibleResults[joinValCount];
        // if (visible)
        //   return;
      } else if (joinValue === ']&&[') {
        visible = previousResult && allVisibleResults[joinValCount];
        // if (visible)
        //   return;
      } else if (joinValue === ']||[') {
        visible = previousResult || allVisibleResults[joinValCount];
        // if (visible)
        //   return;
      }

      previousResult = visible;

    });


    return visible;
  }

  isValid(controlValue: any[] | any, matchControlValue: any, relationalOperatorName: string) {
    const isMultiple = Array.isArray(controlValue);
    let isValid = false;
    switch (relationalOperatorName) {
      case '==':
        isValid = isMultiple ? controlValue?.includes(matchControlValue) : controlValue === matchControlValue;
        break;
      case '!=':
        isValid = isMultiple ? !controlValue?.includes(matchControlValue) : controlValue !== matchControlValue;
        break;
      case '>':
        isValid = parseFloat(controlValue) > parseFloat(matchControlValue);
        break;
      case '<':
        isValid = parseFloat(controlValue) < parseFloat(matchControlValue);
        break;
      case '>=':
        isValid = parseFloat(controlValue) >= parseFloat(matchControlValue);
        break;
      case '<=':
        isValid = parseFloat(controlValue) <= parseFloat(matchControlValue);
        break;
    }


    return isValid;
  }


  // Creating Form Control and Assigning Initial Values
  createControl(fields: FieldConfig[], formData: any) {
    const group: any = {};
    fields.forEach((field) => {
      if (field.type === 'button') {
        return;
      }
      const key = field.key;
      let initialValue = formData ? formData[key] : this.settings.isNullOrUndefined(field.value) ? null : field.value;
      if (field.type === FieldType.checkbox) {
        initialValue = initialValue || false;
      } else {
        initialValue = initialValue == null ? null : initialValue + '';
      }

      group[key] = new UntypedFormControl({
        value: initialValue,
        disabled: field.disabled || false
      }, this.bindValidations(field.validations || []));
    });
    return new UntypedFormGroup(group);
  }

  bindValidations(validations: any[]) {
    if (validations.length > 0) {
      const validList: any[] = [];
      validations.forEach((valid) => {
        validList.push(valid.validator);

      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched({onlySelf: true});
    });
  }

  onSubmit(event: Event, form?: UntypedFormGroup, fields?: FieldConfig[]) {
    event.preventDefault();
    event.stopPropagation();
    if (form) {
      if (form?.valid) {
        const data = form.value;
        fields?.forEach(field => {
          if (field.type === FieldType.date) {
            data[field.key] = this.settings.formatDate(data[field.key], field.dateFormat);
          } else if (field.type === FieldType.input && field.inputType == 'number' && data[field.key]) {
            data[field.key] = parseFloat(data[field.key].toString().replace(/,/g, ''));
          }

        });
        return data;
      } else {
        this.validateAllFormFields(form);
      }
    }
  }

  updateFieldOption(fields: FieldConfig[], fieldKey: string, property: { [id: string]: any }) {
    return fields.map(field => {
      if (field.key === fieldKey) {
        return {
          ...field,
          ...property
        }
      } else {
        return {
          ...field
        }
      }
    })
  }
}
